import { useState, useCallback, useRef } from "react";
import { Plus } from "lucide-react";

export default function FilePicker({ onFilesAdded, disabled }) {
  const [dragActive, setDragActive] = useState(false);
  const fileInputRef = useRef(null);

  const handleFileInput = (e) => {
    const chosen = [...e.target.files];
    if (chosen.length) onFilesAdded(chosen);
    setTimeout(() => (e.target.value = ""), 0);
  };

  const handleDrag = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(e.type === "dragenter" || e.type === "dragover");
  }, []);

  const handleDrop = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      setDragActive(false);
      onFilesAdded([...e.dataTransfer.files]);
    },
    [onFilesAdded]
  );

  return (
    <section className="picker-wrapper">
      <label
        className={`picker ${dragActive ? "drag" : ""} ${disabled ? "disabled" : ""}`}
        onDragEnter={handleDrag}
        onDragLeave={handleDrag}
        onDragOver={handleDrag}
        onDrop={handleDrop}
      >
        <Plus size={56} />
        <h3>Add Files</h3>
        <p>Tap or drag‑and‑drop</p>
        <input
          ref={fileInputRef}
          type="file"
          multiple
          accept="image/*,video/*"
          onChange={handleFileInput}
          className="file-input"
          disabled={disabled}
        />
      </label>
    </section>
  );
}